import { maxBy, some } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import { H_MAT_MODULE } from '../../../account/constants/AccessRulesConstants'
import ActionComponent from '../../../components/ActionComponent'
import AlertPanel from '../../../components/alert/AlertPanel'
import Checkbox from '../../../components/forms/Checkbox'
import DatePicker from '../../../components/forms/DatePicker'
import Input from '../../../components/forms/Input'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import Textarea from '../../../components/forms/Textarea'
import SieauAction from '../../../components/sieau/SieauAction'
import UnitChartPanel from '../../../productionUnit/components/UnitChartPanel'
import ContactCard from '../../../referencial/components/contact/components/ContactCard'
import { SANDRE } from '../../../referencial/constants/ReferencialConstants'
import LinkedStationsPanel from '../../../station/components/associatedStation/LinkedStationsPanel'
import StationMapDashboardPanel from '../../../station/components/dashboard/component/map/StationMapDashboardPanel'
import LastEventPanel from '../../../station/components/event/LastEventPanel'
import MaterielAssigned from '../../../station/components/materiel/MaterielAssigned'
import StationUpdatePanel from '../../../station/components/update/StationUpdatePanel'
import AppStore from '../../../store/AppStore'
import { getColorCircleElement, getRGBColor } from '../../../utils/ColorUtil'
import HabilitationRequired from '../../../utils/components/HabilitationRequired'
import { getDate } from '../../../utils/DateUtil'
import { getControlColor } from '../../../utils/InstallationUtils'
import { hasBooleanValue, hasValue } from '../../../utils/NumberUtil'
import { getMapStateToProps, getPropTypes, getSandreList } from '../../../utils/StoreUtils'
import InstallationAction from '../../actions/InstallationAction'
import { INSTALLATION_TYPE } from '../../constants/InstallationConstants'
import InstallationInfosDashboard from '../installations/components/InstallationInfosDashboard'
import BoreholeAquiferDashboard from './aquifer/components/BoreholeAquiferDashboard'
import InstallationArrangementDashboard from './arrangements/InstallationArrangementDashboard'
import BoreholeCommentDashboard from './boreholeComment/components/BoreholeCommentDashboard'
import BoreholeCasingDashboard from './casing/components/BoreholeCasingDashboard'
import BoreholeDrillingDashboard from './drilling/components/BoreholeDrillingDashboard'
import BoreholeLithologyDashboard from './lithology/components/BoreholeLithologyDashboard'
import { Grid, Card, CardContent, Stack } from '@mui/material'
import WifiIcon from '@mui/icons-material/Wifi'
import { CardTitle } from 'components/card/NewCard'
import InstallationLinkedProduction from '../installationDefault/InstallationLinkedProduction'
import { BoreholeThresholdIndicators } from 'piezometry/components/alerts/thresholds/ThresholdIndicatorsManager'

const storeProps = {
    installation: false,
    cities: false,
    installationBorehole: false,
    watersheds: true,
    status: true,
    users: true,
    sandreCodes: false,
    natures: true,
    aquifers: true,
    fieldModes: true,
    contributors: false,
    installationEvents: false,
}

class BoreholeDashboardPanel extends ActionComponent {
    state = {
        uncheckedStations: [],
    }
    componentWillMount() {
        AppStore.dispatch(SieauAction.fetch(storeProps))
        if (this.props.installation.id) {
            if (this.props.installation.installationType === INSTALLATION_TYPE.BOREHOLE) {
                AppStore.dispatch(InstallationAction.fetchInstallationBorehole(this.props.installation.id))
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.installation.id != nextProps.installation.id) {
            if (nextProps.installation.installationType === INSTALLATION_TYPE.BOREHOLE) {
                AppStore.dispatch(InstallationAction.fetchInstallationBorehole(nextProps.installation.id))
            }
        }
    }

    getAquifer = (borehole) => {
        const found = borehole && borehole.link_aquifers && borehole.link_aquifers.length ? borehole.link_aquifers.find(a => a.order === 0) : null
        return found ? found.aquiferId : null
    }

    getGeoData = (installation) => {
        return installation?.link_geo?.length ? installation.link_geo[0] : {}
    }

    getOriginStatusColor = (installation) => {
        if (hasValue(installation.status)) {
            const color = getControlColor(installation.status)
            return getColorCircleElement(getRGBColor(color), true)
        }
        return null
    }

    getDiagnosticAlertPanel = () => {
        const diagnosticEvents = this.props.installationEvents.filter(i => i.diagnostic && i.diagnosticDeadline)
        if (diagnosticEvents.length) {
            const lastDate = maxBy(diagnosticEvents, 'diagnosticDeadline').diagnosticDeadline
            if (moment().isSameOrAfter(moment(lastDate).year(moment(lastDate).year() - 2))) {
                const color = moment().isSameOrAfter(moment(lastDate).year(moment(lastDate).year() - 1)) ? 'red' : 'orange'
                return (
                    <AlertPanel comment={i18n.diagnosticDeadlineOn + getDate(lastDate)}
                        title={i18n.diagnosticToPlan}
                        icon={'warning'} color={color}
                    />
                )
            }
        }
        return null
    }

    render() {
        const { associatedSites } = this.props

        const installation = this.props.installation
        const borehole = this.props.installationBorehole
        const readMode = { readMode: true, editMode: false, hideNull: true }

        const cartographyData = this.getGeoData(installation)
        const params = {
            station: installation,
        }

        const boreholeParams = {
            station: borehole,
        }

        return (
            <Grid container sx={{ padding: '10px 10px 60px 0' }} spacing={1} alignItems={'flex-start'}>
                <Grid container size={9}>
                    <Grid size={12}>
                        <InstallationInfosDashboard />
                    </Grid>
                    <Grid size={12}>
                        <Card>
                            <CardTitle title={i18n.characteristics}/>
                            <CardContent>
                                <Grid container>
                                    <Grid size={6}>
                                        <Checkbox
                                            componentClassName='padding-bottom-1'
                                            checked={hasValue(installation.exploitationCode) ? installation.exploitationCode == 1 : null}
                                            label={i18n.exploitation}
                                            disabled {...readMode}
                                        />
                                        <Select
                                            value={borehole.nature} label={i18n.nature}
                                            options={this.props.natures}
                                            {...readMode}
                                        />
                                        <Input
                                            value={borehole.use}
                                            title={i18n.use}
                                            {...readMode}
                                        />
                                        <NumberField
                                            title={i18n.depth}
                                            value={borehole.depth ? borehole.depth + i18n.metersSymbol : null}
                                            floatValue
                                            {...readMode}
                                        />
                                        <Input
                                            value={borehole.pumpType}
                                            title={i18n.pumpType}
                                            {...readMode}
                                        />
                                        <Input
                                            value={borehole.hourWaterFlow}
                                            title={i18n.hourWaterFlow}
                                            {...readMode}
                                        />
                                        <Input
                                            value={borehole.yearWaterFlow || (borehole.hourWaterFlow * 20 * 365)}
                                            title={i18n.yearWaterFlow}
                                            {...readMode}
                                        />
                                        <Input
                                            value={borehole.cementationTubing}
                                            title={i18n.cementationTubing}
                                            {...readMode}
                                        />
                                        <Checkbox
                                            checked={borehole.overflowPresence}
                                            label={i18n.overflowPresence}
                                            {...readMode}
                                        />
                                        <Checkbox
                                            checked={borehole.gravitationalStation}
                                            label={i18n.gravitationalStation}
                                            {...readMode}
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <Textarea
                                            value={installation.comments}
                                            title={i18n.comment}
                                            {...readMode}
                                        />
                                        <Checkbox
                                            label={i18n.waterTableAccompaniment}
                                            checked={borehole.waterTableAccompaniment}
                                            disabled
                                            {...readMode}
                                        />
                                        <Select
                                            value={borehole.watershed}
                                            label={i18n.watershed}
                                            options={this.props.watersheds}
                                            keyValue='id'
                                            displayWithCode
                                            {...readMode}
                                        />
                                        <Select
                                            value={this.getAquifer(borehole)}
                                            label={i18n.aquifer}
                                            options={this.props.aquifers}
                                            {...readMode}
                                        />
                                        <Select
                                            value={borehole.fieldMode}
                                            label={i18n.fieldMode}
                                            options={this.props.fieldModes}
                                            {...readMode}
                                        />
                                        <Input
                                            value={borehole.surfaceGeology}
                                            title={i18n.surfaceGeology}
                                            {...readMode}
                                        />
                                        <NumberField
                                            title={i18n.pumpDepth}
                                            value={borehole.pumpDepth ? borehole.pumpDepth + i18n.metersSymbol : null}
                                            floatValue
                                            {...readMode}
                                        />
                                        <NumberField
                                            title={i18n.drillingBlowRate}
                                            value={borehole.drillingBlowRate ? `${borehole.drillingBlowRate} m3/h` : null}
                                            floatValue
                                            {...readMode}
                                        />
                                        <NumberField
                                            title={i18n.overflowRating}
                                            value={borehole.overflowRating}
                                            floatValue
                                            {...readMode}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <UnitChartPanel unit={this.props.installation} uncheckedStations={this.state.uncheckedStations} setDataLoaded={this.props.setDataLoaded} fromStationType='INST' dontShowEmptyCharts />
                    <InstallationLinkedProduction />
                    <InstallationArrangementDashboard {...params} />
                    <Grid container spacing={1} size={12}>
                        {
                            !!borehole?.link_drillings?.length && (
                                <Grid size={6}>
                                    <BoreholeDrillingDashboard {...boreholeParams} />
                                </Grid>
                            )
                        }
                        {
                            !!borehole?.link_casings?.length && (
                                <Grid size={6}>
                                    <BoreholeCasingDashboard {...boreholeParams} />
                                </Grid>
                            )
                        }
                        {
                            !!borehole?.link_lithology?.length && (
                                <Grid size={6}>
                                    <BoreholeLithologyDashboard {...boreholeParams} />
                                </Grid>
                            )
                        }
                        {
                            !!borehole?.link_boreholeComments?.length && (
                                <Grid size={6}>
                                    <BoreholeCommentDashboard {...boreholeParams} />
                                </Grid>
                            )
                        }
                        {
                            !!borehole?.link_aquifers?.filter(({ order }) => order !== 0).length && (
                                <Grid size={6}>
                                    <BoreholeAquiferDashboard {...boreholeParams} />
                                </Grid>
                            )
                        }
                        {
                            (some(['superficialWaterIsolation', 'supIsolationToVerify', 'nonIsolatedWaterTables', 'isolatedWaterTables', 'isolationToVerify'], val => hasBooleanValue(borehole[val])) || hasValue(borehole.isolationComment)) && (
                                <Grid size={6}>
                                    <Card>
                                        <CardTitle title={i18n.permeability} />
                                        <CardContent>
                                            <Grid size={12}>
                                                <Checkbox label={i18n.superficialWaterPermeability} checked={borehole.superficialWaterIsolation} disabled {...readMode} />
                                            </Grid>
                                            <Grid size={12}>
                                                <Checkbox label={i18n.supPermeabilityToVerify} checked={borehole.supIsolationToVerify} disabled {...readMode} />
                                            </Grid>
                                            <Grid size={12}>
                                                <Checkbox label={i18n.nonPermeabilityWaterTables} checked={borehole.nonIsolatedWaterTables} disabled {...readMode} />
                                            </Grid>
                                            <Grid size={12}>
                                                <Checkbox label={i18n.permeabilityWaterTables} checked={borehole.isolatedWaterTables} disabled {...readMode} />
                                            </Grid>
                                            <Grid size={12}>
                                                <Checkbox label={i18n.permeabilityToVerify} checked={borehole.isolationToVerify} disabled {...readMode} />
                                            </Grid>
                                            <Grid size={12} sx={{ paddingTop: '10px' }}>
                                                <Textarea value={borehole.isolationComment} title={i18n.permeabilityComment} {...readMode} />
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        }
                    </Grid>
                </Grid>
                <Grid size={3}>
                    <Stack spacing={1}>
                        <StationUpdatePanel station={installation} />
                        {this.getDiagnosticAlertPanel()}
                        {some(['dataOrigin', 'arrestCode', 'arrestDate', 'endDate', 'closeComment', 'confidential'], key => hasValue(borehole[key]) || hasValue(installation[key])) && (
                            <Card>
                                <CardContent>
                                    <Stack>
                                        {hasValue(installation.jobExecutionId) && (
                                            <Grid container justifyContent='center' alignItems='center' spacing={1}>
                                                <WifiIcon sx={{ fontSize: '40px' }}/>
                                                {i18n.automaticUpdate}
                                            </Grid>
                                        )}
                                        <Input title={i18n.dataOrigin} value={installation.dataOrigin} {...readMode} />
                                        <Select label={[this.getOriginStatusColor(installation), i18n.status]} value={installation.status}
                                            options={this.props.status} {...readMode}
                                        />
                                        <DatePicker value={installation.statusDate} id='statusDate' title={i18n.controlDoneAt} {...readMode} />
                                        <Select label={i18n.controlDoneBy} value={installation.statusLogin}
                                            options={this.props.users.map(u => ({ code: u.login, name: u.name || u.login }))} {...readMode}
                                        />
                                        <Input title={i18n.arrestCode} value={borehole.arrestCode} {...readMode} />
                                        <DatePicker value={borehole.arrestDate} id='arrestDate' title={i18n.arrestDate} {...readMode} />
                                        <NumberField title={i18n.arrestValidityDuration} value={borehole.arrestValidityDuration} floatValue {...readMode} />
                                        <DatePicker value={installation.endDate} id='deliberationDate' title={i18n.deliberationDate} {...readMode} />
                                        <Input value={installation.closeComment} title={i18n.become} {...readMode} />
                                        <Checkbox componentClassName='padding-bottom-1' label={i18n.confidential} {...readMode}
                                            checked={hasValue(installation.confidential) ? installation.confidential == '1' : null} disabled
                                        />
                                    </Stack>
                                </CardContent>
                            </Card>
                        )}
                        {!!associatedSites.length && (
                            <BoreholeThresholdIndicators />
                        )}
                        <ContactCard
                            title={i18n.contact}
                            contactCode={installation.ownerCode}
                            onChange={v => this.onChangeInstallation({ ownerCode: v })}
                            {...readMode}
                        />
                        {some(['address', 'x', 'y', 'altitude', 'parcel', 'section', 'ignMap', 'geologicalMap'], key => hasValue(installation[key])) && (
                            <Card>
                                <CardContent>
                                    <Grid size={12}>
                                        <Input title={i18n.address} value={installation.address} {...readMode} />
                                    </Grid>
                                    <Grid size={12}>
                                        <Select value={installation.townCode} label={i18n.city} options={this.props.cities} keyValue='id' displayWithCode {...readMode} />
                                    </Grid>
                                    <Grid container size={12}>
                                        <Grid size={6}>
                                            <NumberField title='X' value={installation.x} floatValue {...readMode} />
                                        </Grid>
                                        <Grid size={6}>
                                            <NumberField title='Y' value={installation.y} floatValue {...readMode} />
                                        </Grid>
                                    </Grid>
                                    <Grid container size={12}>
                                        <Grid size={6}>
                                            <NumberField title='Z' value={installation.altitude} floatValue {...readMode} />
                                        </Grid>
                                        <Grid size={6}>
                                            <Select label={i18n.projection} value={installation.projection}
                                                options={getSandreList(this.props.sandreCodes, SANDRE.PROJECTION)} {...readMode}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Grid size={6}>
                                            <Input title={i18n.section} value={cartographyData.parcel} {...readMode} />
                                        </Grid>
                                        <Grid size={6}>
                                            <Input title={i18n.parcel} value={cartographyData.section} {...readMode} />
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Grid size={6}>
                                            <Input title={i18n.ignMap} value={cartographyData.ignMap} {...readMode} />
                                        </Grid>
                                        <Grid size={6}>
                                            <Input title={i18n.geologicalMap} value={cartographyData.geologicalMap} {...readMode} />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        )}
                        <HabilitationRequired habilitation={H_MAT_MODULE}>
                            <MaterielAssigned stationId={this.props.installation.id} type={this.props.stationType} />
                        </HabilitationRequired>
                        <LastEventPanel id={this.props.installation.id} events={this.props.installationEvents} stationId={this.props.installation.id}
                            stationType='installation'
                        />
                        <StationMapDashboardPanel noMarkerTooltip station={installation} type={'installation'} />
                        <LinkedStationsPanel
                            onReMount={ this.props.onReMount }
                            dashboardMode
                            checkable
                            changeUncheckedStations={ tab => this.setState({ uncheckedStations: tab })}
                            station={this.props.installation}
                            withColors
                            hideTitle
                        />
                    </Stack>
                </Grid>
            </Grid>
        )
    }
}

BoreholeDashboardPanel.propTypes = getPropTypes(storeProps, {
    setDataLoaded: PropTypes.func,
    stationType: PropTypes.string,
})

const mapStateToProps = (store) => getMapStateToProps(storeProps, {
    associatedSites: store.StationReducer.associatedSites,
})

export default connect(mapStateToProps)(BoreholeDashboardPanel)